module.exports = __webpack_public_path__ + "static/media/YM83_2.5827ec15.jpg";